import { useList } from "stores/hooks/list";
import { useListEntities } from "stores/hooks/list-entities";
import { FunctionComponent } from "react";
import { Navigate } from "react-router";
import { useAuthListUser } from "stores/hooks/auth";

interface UserListViewProps {}

const UserListView: FunctionComponent<UserListViewProps> = () => {
  // this view does not do any functionality but to redirect user
  const list = useList();
  const listEntities = useListEntities();
  const listUser = useAuthListUser();

  // nothing, if no list yet
  if (!list || !listEntities || listEntities.length === 0 || !listUser) {
    return null;
  }

  // redirect approved or submitted users to the summary page
  if (listUser.status === "approved" || listUser.status === "submitted") {
    return <Navigate to={`/user/list/${list.uuid}/summary`} />;
  }

  // if the list has obligation, that will be the first one
  if (list.obligation) {
    return <Navigate to={`/user/list/${list.uuid}/obligation`} />;
  }

  // redirect to first entity
  const [first] = listEntities;
  if (!first) {
    throw new Error("No list entity found!");
  }
  return <Navigate to={`/user/list/${list.uuid}/entity/${first.uuid}`} />;
};

export default UserListView;
